import _ from 'lodash';
import * as api from './api';
import * as yup from 'yup';
import * as helpers from 'services/helpers';

export const fetchStoragePlan = async (params = {}) => {
  try {
    const res = await api.fetchStoragePlan(params);
    return res;
  } catch (err) {
    throw err;
  }
};
